var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('h2',{staticClass:"text-center"},[_vm._v("Welcome to Admin Panel")])])
}]

export { render, staticRenderFns }